export default {
  'tasks.general.form.description': 'Descrição do Serviço',
  'tasks.general.form.temporaryCode': 'Código Tempário',
  'tasks.general.form.area': 'Área',
  'tasks.general.form.KMManager': 'KM Manutenção',
  'tasks.general.form.time': 'Tempo',
  'tasks.general.form.unity': 'Unidade',
  'tasks.general.form.lifespanDay': 'Vida Útil (dias)',
  'tasks.general.form.observation': 'Observações',
  'tasks.general.form.button.remove': 'Remover',
  'tasks.general.form.button.save': 'Salvar',
  'tasks.modal.remove.title': 'Remover serviço',
  'tasks.modal.remove.content': 'Deseja remover o serviço',
  'tasks.modal.remove.button.ok': 'Remover',
  'tasks.modal.remove.message.success': 'Serviço removido com sucesso!',
  'tasks.modal.remove.message.error': 'Não foi possível remover o serviço!',
  'tasks.page.button.generateReport': 'Gerar Relatório',
  'tasks.page.button.changePrices': 'Alterar Preços',
  'tasks.page.button.newTask': 'Novo Serviço',
  'tasks.general.companies.price': 'Preço por Empresas',
  'tasks.general.companies.price.list.name': 'Empresa',
  'tasks.general.companies.price.list.amountTime': 'Valor/Hora',
  'tasks.general.companies.price.list.amount': 'Valor Total',
  'tasks.report.form.area': 'Área',
  'tasks.report.form.company': 'Empresa',
  'tasks.report.form.date': 'Data Ínicio/Fim',
  'tasks.changePrices.modal.title': 'Alterar Preços',
  'tasks.changePrices.modal.message.success': 'Preços alterados com sucesso!',
  'tasks.changePrices.modal.message.error':
    'Não foi possível alterar os preços!',
  'tasks.changePrice.form.type.all': 'Todos os Serviços',
  'tasks.changePrice.form.type.area': 'Por Área',
  'tasks.changePrice.form.company': 'Selecione uma Empresa',
  'tasks.changePrice.form.area': 'Selecione uma Área',
  'tasks.changePrice.form.typeValue.value': 'Por Valor',
  'tasks.changePrice.form.typeValue.percent': 'Por Percentual',
  'tasks.changePrice.form.price': 'Preço',
  'tasks.form.description': 'Descrição do serviço',
  'tasks.form.temporaryCode': 'Código Tempário',
  'tasks.form.area': 'Área',
  'tasks.form.maintenanceKm': 'Km manutenção',
  'tasks.form.nbsCode': 'NBS',
  'tasks.form.maintenanceTime': 'Tempo manutenção',
  'tasks.form.unit': 'Unidade',
  'tasks.form.unit.validator.max': 'A unidade deve ter no máximo 2 caracteres.',
  'tasks.form.time': 'Tempo',
  'tasks.form.lifeSpan': 'Vida útil (dias)',
  'tasks.form.note': 'Observações',
  'tasks.form.taskPrices': 'Preço do Serviço',
  'tasks.form.taskPrices.company': 'Empresa',
  'tasks.form.taskPrices.price': 'Preço (R$)',
  'tasks.form.taskPrices.fixedServiceCost': 'Custo Fixo do Serviço',
  'tasks.form.taskPrices.commissionPercentage': '(%) Comissão',
  'tasks.create.notification.success': 'Sucesso',
  'tasks.create.notification.successDescription': 'Serviço criado.',
  'tasks.create.notification.error': 'Erro',
  'tasks.create.notification.errorDescription': 'Falha ao criar o serviço.',

  'tasks.update.notification.success': 'Sucesso',
  'tasks.update.notification.successDescription': 'Serviço atualizado.',
  'tasks.update.notification.successDescriptionAll': 'Serviços atualizados.',

  'tasks.remove': 'Remover Serviço',
  'tasks.remove.alert': 'Você realmente deseja remover o serviço:',
  'tasks.remove.notification.success': 'Sucesso',
  'tasks.remove.notification.successDescription': 'Serviço removida.',

  'tasks.modal.report.title': 'Gerar Relatório',
  'tasks.modal.report.buttons.viewReport': 'Visualizar Relatório',
  'tasks.modal.report.buttons.pdf': 'Gerar PDF',
  'tasks.modal.report.buttons.rtf': 'Gerar RTF',
  'tasks.modal.report.buttons.csv': 'Gerar CSV',
  'tasks.modal.report.form.description': 'Descrição',
  'tasks.modal.report.form.descriptionUpUntil': 'Até',
  'tasks.modal.report.form.area': 'Área',
  'tasks.modal.report.form.time': 'Tempo',
  'tasks.modal.report.form.timeUpUntil': 'Até',
  'tasks.modal.report.form.companies': 'Empresas',

  'tasks.application.list.header.automaker': 'Montadora',
  'tasks.application.list.header.model': 'Modelo',
  'tasks.application.list.header.modelVersion': 'Versão do Modelo',
  'tasks.application.list.header.time': 'Tempo',
  'tasks.application.modal.create.success.title': 'Sucesso!',
  'tasks.application.modal.create.success.description':
    'Aplicação do serviço criada com sucesso',
  'tasks.application.modal.remove.success.description':
    'Aplicação removida com sucesso',
  'tasks.application.modal.update.success.description':
    'Aplicação atualizada com sucesso',

  'task.list.action.button': 'Ver/Editar',
  'task.list.action.DeleteButton.remove': 'Remover',

  'task.application.form.automaker': 'Montadora',
  'task.application.form.model': 'Modelo',
  'task.application.form.modelVersion': 'Versão do Modelo',
  'task.application.form.time': 'Tempo',
  'task.application.form.add': 'Adicionar',

  'task.application.vehicles.create': 'Criar',
  'task.application.modal.addApplication': 'Adicionar Aplicação',

  'task.status.message.success': 'Status do Serviço alterado com sucesso!',

  'task.status.message.success': 'Status do Serviço alterado com sucesso!',

  'task.changePrice.dropDown.allTasks': 'Todos os serviços',
  'task.changePrice.dropDown.byArea': 'Por área',
  'task.changePrice.modal.title': 'Alteração de preços',
  'task.changePrice.modal.company': 'Empresa',
  'task.changePrice.modal.areas': 'Áreas',
};
